import classes from './UserAgeGroup.module.css';
import { useDispatch, useSelector } from 'react-redux';
import ageGroups from '../../../store/ageGroups/AgeGroups';
import React, { useState, useEffect } from 'react';
import { LanguageContext } from '../../../context/LanguageContext';
import ComponentsTitle from '../userAccountTitle/componentsTitle/ComponentsTitle';
import AgeGroup from '../../../components/user/userAccountComponent/ageGroup/AgeGroup';
import ChangeDataButtons from '../../../components/user/editData/changeDataButtons/ChangeDataButtons';
import UserAccountComponent from '../../../components/user/userAccountComponent/UserAccountComponent';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import Cookies from "js-cookie";
import editUserConfigs from '../../../store/user/editConfigs/EditUserConfigs';
import { editUserConfigsAction } from '../../../store/user/editConfigs/EditUserConfigsSlice';

const UserAgeGroup = (props) => {
  const { setData, data, userAgeGroup } = props
  const dispatch = useDispatch();
  const [ageData, setAgeData] = useState([]);
  const [ageGroup, setAgeGroup] = useState(false);
  const { user, refetchUser } = useCurrentUser();
  const ageGroupData = useSelector((state) => state.ageGroups.ageGroups.data);
  const editUserConfigsData = useSelector((state) => state.editUserConfigs);
  const token = Cookies.get("auth_token");

  useEffect(() => {
    dispatch(ageGroups());
  }, [dispatch]);

  useEffect(() => {
    setAgeGroup(data === 'ageGroup')
  }, [data])

  const cancel = (e) => {
    e.preventDefault();
    setAgeGroup(false);
    setAgeData(user?.ageGroup);
  };

  useEffect(() => {
    if (user) {
      setAgeData(user?.ageGroup);
    }
  }, [user, data]);

  const changeAgeGroup = (e) => {
    if (e.target.checked && !ageData?.includes(e.target.value)) {
      setAgeData([...ageData, e.target.value]);
    } else {
      const deleteAge = ageData.filter((data) => data !== e.target.value);
      setAgeData(deleteAge);
    }
  };

  useEffect(() => {
    userAgeGroup(ageData);
  }, [props, ageData, userAgeGroup]);

  const ageGroupHandler = async (e) => {
    e.preventDefault();

    dispatch(editUserConfigs(token, { ageGroup: ageData}));
  };

  const showData = () => {
    setAgeGroup(true);
    setData('ageGroup')
  };

  useEffect(() => {
    if (editUserConfigsData?.status === "succeeded") {
      refetchUser();
      setAgeGroup(false);
      dispatch(editUserConfigsAction.editUserConfigsReset());
    } else if (editUserConfigsData?.status === "failed") {
      setAgeData(user?.ageGroup);
      setAgeGroup(false);
      dispatch(editUserConfigsAction.editUserConfigsReset());
    }
  }, [dispatch, editUserConfigsData, refetchUser, user?.ageGroup])

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <>
            <ComponentsTitle title={ctx.data?.age_group[ctx.language]} />
            <form
              method='post'
              onSubmit={ageGroupHandler}
              className={`${classes.gap_20} flex-wrap w-100 d-flex`}
            >
              <UserAccountComponent action={ctx.data?.edit[ctx.language]} titleAge={true}>
                <AgeGroup
                  onSubmit={ageGroupHandler}
                  ageGroup={ageGroupData}
                  onChangeaAge={changeAgeGroup}
                  data={ageData}
                  onClick={showData}
                />
              </UserAccountComponent>
              {ageGroup ? <ChangeDataButtons cancel={cancel} /> : null}
            </form>
          </>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default UserAgeGroup;
